import { useState } from 'react';
import languages from '.';
import { types } from './interface';
let languageType = localStorage.getItem('language');
if (!types.includes(languageType)) {
    languageType = 'en';
}
const storedLanguage = languages[languageType];
const appUseLanguage = () => {
    return useState(storedLanguage);
};
export default appUseLanguage;
